module.exports = __webpack_public_path__ + "static/media/game-board.7713413a.svg";